/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React from 'react';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import styles from './MiniPlayground.module.less';
import LineResult from '../../details/runs/items/LineResult';
import { ISentence } from '../../pages/PlaygroundV3/components/Editor/editorInterface';

interface IMiniPlaygroundLineResultProps {
  selectedStep: any;
  setSelectedStep: (step: ISentence | null) => void;
}

function MiniPlaygroundLineResult(props: IMiniPlaygroundLineResultProps) {
  return (
    <div
      className={styles.contentAnswerContainer}
      data-cy="mini-playground-selected-answer"
    >
      <div className={styles.contentAnswerActions}>
        <Button
          icon={<ArrowLeftOutlined />}
          type="text"
          onClick={() => props.setSelectedStep(null)}
          data-cy="mini-playground-selected-answer-back"
        >
          Back
        </Button>
      </div>
      <div className={styles.contentAnswer}>
        <LineResult step={props.selectedStep} />
      </div>
    </div>
  );
}

export default MiniPlaygroundLineResult;
